module.exports = bootstrap_app;


//////////////////
// WEBPACK FOOTER
// external "bootstrap_app"
// module id = 489
// module chunks = 6